import styled from "styled-components";

export const ModalContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 500px;
  max-height: 85vh;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  color: #fff;
`;

export const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  svg {
    flex-shrink: 0;
  }

  h6 {
    color: #fff;
  }

  .MuiTypography-body2 {
    color: rgba(255, 255, 255, 0.85);
  }
`;

export const Content = styled.div`
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  max-height: 60vh;
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  text-align: center;
`;

export const Timeline = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    left: 15px;
    top: 0;
    bottom: 0;
    width: 2px;
    background-color: #e0e0e0;
  }
`;

interface TimelineItemProps {
  isCurrent?: boolean;
}

export const TimelineItem = styled.div<TimelineItemProps>`
  display: flex;
  gap: 15px;
  position: relative;
  padding-bottom: 20px;

  &:last-child {
    padding-bottom: 0;

    &::before {
      display: none;
    }
  }
`;

export const TimelineMarker = styled.div<TimelineItemProps>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${(props) => (props.isCurrent ? "#1976d2" : "#fff")};
  border: 2px solid ${(props) => (props.isCurrent ? "#1976d2" : "#bdbdbd")};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  flex-shrink: 0;

  svg {
    color: ${(props) => (props.isCurrent ? "#fff" : "#757575")};
  }
`;

export const TimelineContent = styled.div`
  flex: 1;
  padding-top: 4px;
`;

export const DentistCard = styled.div<TimelineItemProps>`
  background-color: ${(props) => (props.isCurrent ? "#e3f2fd" : "#f5f5f5")};
  border: 1px solid ${(props) => (props.isCurrent ? "#90caf9" : "#e0e0e0")};
  border-radius: 12px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

interface BadgeProps {
  type: "first" | "current";
}

export const Badge = styled.span<BadgeProps>`
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 4px 10px;
  border-radius: 20px;
  width: fit-content;
  margin-bottom: 5px;

  ${(props) =>
    props.type === "current"
      ? `
    background-color: #1976d2;
    color: #fff;
  `
      : `
    background-color: #fff3e0;
    color: #ef6c00;
  `}
`;

export const DentistName = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #333;

  svg {
    color: #1976d2;
  }
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #666;

  svg {
    color: #9e9e9e;
  }
`;

export const ChangeInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #666;
  margin-top: 5px;
  padding-top: 8px;
  border-top: 1px dashed #e0e0e0;

  svg {
    color: #ff9800;
  }
`;

export const ChangedBy = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: #9e9e9e;
  margin-top: 5px;

  svg {
    color: #bdbdbd;
  }
`;















